import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Button, Flex } from 'antd';
import { FC, SetStateAction } from 'react';
import { Calendar } from '../../common/calendar';
import { useHolidays } from '../../common/calendar/utils';
import {
  ActionButton,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Padding,
  TextEllipsis,
} from '../../common/components';
import { ISODate } from '../../common/utils';
import translations from '../translations/CalendarSelectModal.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'calendar-select-modal',
);
addTranslations(translations);

export const CalendarSelectModal: FC<{
  title: string;
  isOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
  selected: Set<ISODate>;
  onSelect: (selected: SetStateAction<Set<ISODate>>) => void;
}> = ({ title, isOpen, onOk, onCancel, selected, onSelect }) => {
  const { t } = useTranslation();
  const { holidays } = useHolidays();

  return (
    <Modal
      open={isOpen}
      destroyOnHidden
      onCancel={onCancel}
      width={658}
      footer={
        <ModalFooter>
          <Flex gap="small" justify="end">
            <ActionButton type="abort" onClick={onCancel} />
            <Button id="mainAction" type="primary" onClick={onOk}>
              {t('button.ok')}
            </Button>
          </Flex>
        </ModalFooter>
      }
    >
      <ModalHeader>
        <ModalTitle>
          <TextEllipsis>{title}</TextEllipsis>
        </ModalTitle>
      </ModalHeader>
      <Padding scrollable>
        <Calendar
          id="calendarSelect"
          holidays={holidays}
          onSelect={onSelect}
          value={selected}
        />
      </Padding>
    </Modal>
  );
};
